import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_LLM_PROVIDERS = 'GET_LLM_PROVIDERS';
export const GET_LLM_PROVIDERS_SUCCESS = 'GET_LLM_PROVIDERS_SUCCESS';
export const GET_LLM_PROVIDERS_ERROR = 'GET_LLM_PROVIDERS_ERROR';
export const GET_LLM_PROVIDERS_RESET = 'GET_LLM_PROVIDERS_RESET';

export const getLLMProvidersApi = (params = {}) => {
	return async (dispatch) => {
		dispatch({ type: GET_LLM_PROVIDERS });
		try {
			const response = await axios.get(
				`${config.api.base_url}/settings/llm-providers`,
				{
					headers: {
						'Content-type': 'application/json; charset=UTF-8',
						Authorization: 'Bearer ' + getUserToken(),
					},
					params,
				},
			);
			dispatch({
				type: GET_LLM_PROVIDERS_SUCCESS,
				payload: response.data,
			});
		} catch (error) {
			dispatch({
				type: GET_LLM_PROVIDERS_ERROR,
				payload: error.response?.data || error.message,
			});
		}
	};
};

export const getLLMProvidersReset = () => ({
	type: GET_LLM_PROVIDERS_RESET,
}); 